import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const ImportantLinks = () => {
  return (
    <>
      <Helmet>
        <title>Important Links - Dental Stores</title>
        <meta name="description" content="Find important links and resources at Dental Stores including policies, guidelines, and external resources." />
      </Helmet>
      <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '28px', fontWeight: '600', marginBottom: '20px', color: '#30363C' }}>Important Links</h1>

        <h2 style={{ fontSize: '22px', fontWeight: '600', marginTop: '30px', marginBottom: '15px', color: '#30363C' }}>Internal Links</h2>
        <div style={{ marginBottom: '30px' }}>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '10px' }}>
              <Link to="/about-us" style={{ color: '#1565C0', textDecoration: 'none' }}>
                About Us - Learn about our mission and values
              </Link>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <Link to="/contact-us" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Contact Us - Get in touch with our team
              </Link>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <Link to="/careers" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Careers - Join our growing team
              </Link>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <Link to="/faq" style={{ color: '#1565C0', textDecoration: 'none' }}>
                FAQ - Find answers to common questions
              </Link>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <Link to="/refunds" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Refunds - Our refund policy
              </Link>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <Link to="/payments" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Payments - Payment methods and security
              </Link>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <Link to="/rewards" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Rewards - Learn about our rewards program
              </Link>
            </li>
          </ul>
        </div>

        <h2 style={{ fontSize: '22px', fontWeight: '600', marginTop: '30px', marginBottom: '15px', color: '#30363C' }}>External Links</h2>
        <div style={{ marginBottom: '30px' }}>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://www.dciindia.gov.in" target="_blank" rel="noopener noreferrer" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Dental Council of India - Official regulatory body
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://www.ada.org" target="_blank" rel="noopener noreferrer" style={{ color: '#1565C0', textDecoration: 'none' }}>
                American Dental Association - International dental standards
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://www.who.int/health-topics/oral-health" target="_blank" rel="noopener noreferrer" style={{ color: '#1565C0', textDecoration: 'none' }}>
                WHO Oral Health - Global oral health information
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="https://www.fdiworlddental.org" target="_blank" rel="noopener noreferrer" style={{ color: '#1565C0', textDecoration: 'none' }}>
                FDI World Dental Federation - International dental organization
              </a>
            </li>
          </ul>
        </div>

        <h2 style={{ fontSize: '22px', fontWeight: '600', marginTop: '30px', marginBottom: '15px', color: '#30363C' }}>Resources</h2>
        <div style={{ marginBottom: '30px' }}>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '10px' }}>
              <a href="#" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Product Catalog - Browse our complete product range
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="#" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Dental Care Guide - Tips for maintaining oral health
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="#" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Professional Resources - Tools for dental practitioners
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="#" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Training Materials - Educational content and webinars
              </a>
            </li>
          </ul>
        </div>

        <h2 style={{ fontSize: '22px', fontWeight: '600', marginTop: '30px', marginBottom: '15px', color: '#30363C' }}>Legal & Compliance</h2>
        <div style={{ marginBottom: '30px' }}>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '10px' }}>
              <Link to="/refunds" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Refund Policy
              </Link>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <Link to="/payments" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Payment Security Policy
              </Link>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="#" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Privacy Policy
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="#" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Terms of Service
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="#" style={{ color: '#1565C0', textDecoration: 'none' }}>
                Shipping Policy
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default ImportantLinks;